/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppMyWorkRouteImport } from './routes/_app/my-work'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppTrashRouteImport } from './routes/_app/trash'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as ResetPasswordTokenRouteImport } from './routes/reset-password.$token'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppProjectsProjectIdRouteImport } from './routes/_app/projects/$projectId'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings.notifications'
import { Route as AppTKeyRouteImport } from './routes/_app/t.$key'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppMyWorkRoute = AppMyWorkRouteImport.update({
  id: '/my-work',
  path: '/my-work',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppTrashRoute = AppTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AppRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => AppRoute,
  } as any)
const AppTKeyRoute = AppTKeyRouteImport.update({
  id: '/t/$key',
  path: '/t/$key',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/admin': typeof AppAdminRoute
  '/my-work': typeof AppMyWorkRoute
  '/profile': typeof AppProfileRoute
  '/trash': typeof AppTrashRoute
  '/invite/$token': typeof InviteTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/t/$key': typeof AppTKeyRoute
  '/projects/': typeof AppProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/admin': typeof AppAdminRoute
  '/my-work': typeof AppMyWorkRoute
  '/profile': typeof AppProfileRoute
  '/trash': typeof AppTrashRoute
  '/invite/$token': typeof InviteTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/': typeof AppIndexRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/t/$key': typeof AppTKeyRoute
  '/projects': typeof AppProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/_app/admin': typeof AppAdminRoute
  '/_app/my-work': typeof AppMyWorkRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/trash': typeof AppTrashRoute
  '/invite/$token': typeof InviteTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/t/$key': typeof AppTKeyRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/admin'
    | '/my-work'
    | '/profile'
    | '/trash'
    | '/invite/$token'
    | '/reset-password/$token'
    | '/projects/$projectId'
    | '/settings/notifications'
    | '/t/$key'
    | '/projects/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/admin'
    | '/my-work'
    | '/profile'
    | '/trash'
    | '/invite/$token'
    | '/reset-password/$token'
    | '/'
    | '/projects/$projectId'
    | '/settings/notifications'
    | '/t/$key'
    | '/projects'
  id:
    | '__root__'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/_app/admin'
    | '/_app/my-work'
    | '/_app/profile'
    | '/_app/trash'
    | '/invite/$token'
    | '/reset-password/$token'
    | '/_app/'
    | '/_app/projects/$projectId'
    | '/_app/settings/notifications'
    | '/_app/t/$key'
    | '/_app/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  InviteTokenRoute: typeof InviteTokenRoute
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-work': {
      id: '/_app/my-work'
      path: '/my-work'
      fullPath: '/my-work'
      preLoaderRoute: typeof AppMyWorkRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trash': {
      id: '/_app/trash'
      path: '/trash'
      fullPath: '/trash'
      preLoaderRoute: typeof AppTrashRouteImport
      parentRoute: typeof AppRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/$token': {
      id: '/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/t/$key': {
      id: '/_app/t/$key'
      path: '/t/$key'
      fullPath: '/t/$key'
      preLoaderRoute: typeof AppTKeyRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRoute
  AppMyWorkRoute: typeof AppMyWorkRoute
  AppProfileRoute: typeof AppProfileRoute
  AppTrashRoute: typeof AppTrashRoute
  AppIndexRoute: typeof AppIndexRoute
  AppProjectsProjectIdRoute: typeof AppProjectsProjectIdRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppTKeyRoute: typeof AppTKeyRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRoute,
  AppMyWorkRoute: AppMyWorkRoute,
  AppProfileRoute: AppProfileRoute,
  AppTrashRoute: AppTrashRoute,
  AppIndexRoute: AppIndexRoute,
  AppProjectsProjectIdRoute: AppProjectsProjectIdRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppTKeyRoute: AppTKeyRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  InviteTokenRoute: InviteTokenRoute,
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
